module.exports = __webpack_public_path__ + "static/daoji-8edb632f8b238b6237652c08ab1942d1.jpg";